<template>
  <app-layout title="Создать заявку">
    <v-layout align-center justify-center>
      <v-dialog v-model="cancelDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Отменить выкуп?</v-card-title>
          <v-card-text>
            <v-select
              :items="refusals"
              item-text="name"
              item-value="id"
              v-model="selectedRefusal"
              label="Причина"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click="cancelDialog = false">Отмена</v-btn>
            <v-btn color="green darken-1" flat @click="handleCancel">Отправить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card max-width="465px" width="100%" raised>
        <v-card-title>
          <h2>
            {{ stepHeaders[step] }}
          </h2>
        </v-card-title>
        <v-card-text :class="{'v-card__fixed': !['all-info','user-info'].includes(step)}">
          <v-divider />
          <v-layout align-center justify-center>
            <div class="text-xs-center" v-if="isFetching">
              <v-progress-circular
                :size="70"
                :width="7"
                color="grey"
                indeterminate
              ></v-progress-circular>
            </div>
            <v-form v-model="valid" v-if="!isFetching">
              <template v-if="step === 'start'">
                <v-text-field
                  label="Номер договора"
                  :rules="formRules.name"
                  v-model="form.id"
                  required
                ></v-text-field>
              </template>
              <template v-if="step === 'device-info'">
                <simple-info-table :items="deviceInfo" />
                <!-- <v-text-field
                  v-if="showSn"
                  label="Серийный номер"
                  v-model="form.sn"
                ></v-text-field>
                <v-btn color="grey" class="white--text" small @click="showSn = !showSn">
                  {{ !showSn ? '+ серийный номер' : 'Отмена' }}
                </v-btn> -->
              </template>
              <template v-if="step === 'user-info'">
                <v-text-field
                  label="ФИО"
                  :rules="formRules.name"
                  v-model="form.name"
                  required
                ></v-text-field>
                <v-text-field
                  label="Телефон"
                  v-model="form.phone"
                  mask="+7(###) ### - ####"
                ></v-text-field>
                <v-text-field
                  label="Номер удостоверения личности"
                  :rules="formRules.name"
                  v-model="form.passportSerial"
                  required
                ></v-text-field>
                <v-text-field
                  label="ИИН"
                  :rules="formRules.name"
                  v-model="form.passportNumber"
                  required
                ></v-text-field>
                <v-text-field
                  label="Дата выдачи удостоверения"
                  mask="##-##-####"
                  :rules="formRules.name"
                  v-model="form.passportDate"
                ></v-text-field>
                <v-text-field
                  label="Кем выдано"
                  :rules="formRules.name"
                  v-model="form.passportIssued"
                  required
                ></v-text-field>
                <v-text-field
                  label="Адрес регистрации"
                  :rules="formRules.name"
                  v-model="form.address"
                  required
                ></v-text-field>
                <v-text-field
                  label="Email"
                  :rules="[formRules.email]"
                  v-model="form.email"
                ></v-text-field>
                <v-text-field
                  label="Дата рождения"
                  mask="##-##-####"
                  :rules="formRules.name"
                  v-model="form.birthday"
                ></v-text-field>
              </template>
              <template v-if="step === 'all-info'">
                <v-subheader>Устройство</v-subheader>
                <simple-info-table :items="deviceInfo" />
                <v-subheader>Покупатель</v-subheader>
                <simple-info-table :items="userInfo" />
              </template>
              <template v-if="step === 'print'">
                <div>
                  <v-alert
                    :value="successMessage"
                    type="success"
                    :dismissible="false"
                    outline
                    transition="scale-transition"
                  >
                    Успешно! Распечатайте договор.
                  </v-alert>
                  <v-layout justify-center>
                    <v-btn color="info" :href="formPdfLink" target="_blank">Печать</v-btn>
                  </v-layout>
                </div>
              </template>
              <p />
            </v-form>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout v-if="!isFetching && step !== 'print'" justify-end>
            <v-btn
              v-if="step !== 'start'"
              class="white--text"
              @click="cancelDialog = true"
              large
              color="red"
            >
              Отмена выкупа
            </v-btn>
            <v-btn @click="handleNext" large :dark="valid" :disabled="!valid">
              Далее
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-layout>
  </app-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AppLayout from '../components/AppLayout.vue';
import SimpleInfoTable from '../components/SimpleInfoTable.vue';

export default {
  components: {
    AppLayout,
    SimpleInfoTable,
  },
  data: () => ({
    step: 'start',
    cancelDialog: false,
    selectedRefusal: null,
    steps: [
      'start',
      'device-info',
      'user-info',
      'all-info',
      'print',
    ],
    stepHeaders: {
      start: 'Выкупить по номеру договора',
      'device-info': 'Данные о выкупе',
      'user-info': 'Данные о клиенте',
      'all-info': 'Данные о выкупе',
      print: 'Печать договора',
    },
    formPdfLink: null,
    valid: false,
    showSn: false,
    successMessage: true,
    form: {
      id: '',
      name: '',
      sn: '',
      passportSerial: '',
      passportNumber: '',
      phone: '',
      passportDate: null,
      passportIssued: '',
      address: '',
      email: '',
      birthday: null,
    },
    formRules: {
      name: [v => !!v || 'Поле обязательно для заполнения'],
      email: (v) => {
        if (!v) {
          return false;
        }
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || 'Некоректный e-mail.';
      },
    },
  }),
  created() {
    const { params } = this.$route;
    if (params && params.id) {
      this.form.id = params.id;
      this.loadDeviceInfo(params.id);
      this.switchStep();
    }
    const { query } = this.$route;
    if (query && query.id) {
      this.form.id = query.id;
      this.loadDeviceInfo(query.id);
      this.switchStep();
    }
    this.loadRefusals().then((res) => {
      this.selectedRefusal = res && res.length && res[0].id;
    });
  },
  methods: {
    ...mapActions('buyout', [
      'loadDeviceInfo',
      'createOrder',
      'updateOrder',
    ]),
    ...mapActions('orders', [
      'updateOrder',
    ]),
    ...mapActions('refusals', [
      'loadRefusals',
    ]),
    handleNext() {
      if (this.step === 'start') {
        this.$router.push({
          name: 'buy-phones',
          params: {
            btag: this.form.id
          }
        });
        // this.loadDeviceInfo(this.form.id);
      }
      if (this.step === 'all-info') {
        const { id, ...rest } = this.form;
        this.createOrder({
          id,
          form: { ...rest },
        }).then(({ status, pdflink }) => {
          if (status == '3') {
            this.formPdfLink = '/'+pdflink;
            this.switchStep();
          }
        });
      } else {
        this.switchStep();
      }
    },
    handleCancel() {
      const { id } = this.form;
      this.updateOrder({
        id,
        refusal: this.selectedRefusal,
      }).then(() => {
        this.$router.push({ name: 'orders' });
      });
    },
    switchStep() {
      this.step = this.steps[this.steps.indexOf(this.step) + 1];
    },
  },
  computed: {
    ...mapGetters('buyout', ['info', 'isFetching']),
    ...mapGetters('refusals', { refusals: 'list' }),
    deviceInfo() {
      if (!this.info.device) return [];
      const info = this.info.device;
      return [
        { name: 'Название', value: info.name },
        // { name: 'производитель', value: info.manafacture },
        // { name: 'Процессор', value: info.processor },
        // { name: 'Оперативная память', value: info.memory },
        // { name: 'Тип диска', value: info.storage_type },
        // { name: 'Объем диска', value: info.storage_capacity },
        { name: 'Цена', value: this.info.price },
      ];
    },
    userInfo() {
      return [
        { name: 'Имя', value: this.form.name },
        { name: 'Серия паспорта', value: this.form.passportSerial },
        { name: 'Номер паспорта', value: this.form.passportNumber },
        { name: 'Дата выдачи', value: this.form.passportDate },
        { name: 'Кем выдан', value: this.form.passportIssued },
        { name: 'Адрес регистрации', value: this.form.address },
        { name: 'Email', value: this.form.email },
        { name: 'Дата рождения', value: this.form.birthday },
      ];
    },
  },
};
</script>

<style scoped>
  h2 {
    font-weight: 400;
  }
  .v-alert {
    margin-bottom: 50px;
  }
  .v-card__fixed {
    height: 350px
  }
  .v-card__text > .layout {
    height: 100%
  }
  .v-form {
    width: 100%;
  }
</style>
